/* eslint-disable */
import styled from "styled-components";
import LOGO from "@/assets/images/logo.svg";

// import { useNavigate } from 'react-router-dom'

export const HeaderTitle = () => {
  const iconWidth = 40;
  // const navigate = useNavigate();

  //返回，<2返回到首页，其他返回上一页
  const goBack = () => {
    // navigate('/home')
  };
  return (
    <header onClick={goBack}>
      <Warper>
        <img src={LOGO} alt="logo" width={iconWidth} />
        <div className="title">紫东太初</div>
        <div className="subTitle">紫东太初数字人创作平台</div>
      </Warper>
    </header>
  );
};

const Warper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  .title {
    font-family: Source Han Sans CN;
    font-size: 30px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
  }
  .subTitle {
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: 300;
    line-height: 14px;
    text-align: left;
    color: #595959;
  }
`;

export default HeaderTitle;
